// extracted by mini-css-extract-plugin
export var filterIncDec = "_41-0";
export var leftBorder = "_41-1";
export var rightBorder = "_41-2";
export var stringInput = "_41-3";